module.exports = __webpack_public_path__ + "static/img/spot2419-2.aaf3386.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spot2419-2.png
// module id = 2STX
// module chunks = 0